/** Returns a sort key where every digit sequence is zero-padded so numbers sort
 *  numerically regardless of position, e.g. "EOP 2" < "EOP 11" < "EOP 23". */
export const naturalSortKey = (s: string): string =>
  s.replace(/\d+/g, (m) => m.padStart(20, "0"));
